import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import {
  setDownloadLimitOverFlg,
  executeFileDownload,
} from '../../actions/ExternalDataHistoryAction';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import styles from './ExternalDataHistoryDownloadComponent.module.css';

class CompanyDownloadComponent extends Component {
  onClickCreateDownloadFile = async () => {
    const {
      executeFileDownloadAct,
      setDownloadLimitOverFlgAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    setDownloadLimitOverFlgAct(false);
    // 外部連携取込履歴ダウンロードファイル取得
    await executeFileDownloadAct();
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      downloadLimitOverFlg,
      downloadLimitOverMsg,
      setDownloadLimitOverFlgAct,
    } = this.props;

    return (
      downloadLimitOverFlg && (
        <div className={`${styles.externallistdownload}`}>
          <div className={`${styles.limitovercontents}`}>
            <div className={`${styles.conf}`}>
              {downloadLimitOverMsg}
            </div>
            <div className={`${styles.limitoverbutton}`}>
              <Button
                variant="contained"
                className={`${styles.downloadLimitOverCancelButton} cancel`}
                onClick={(() => setDownloadLimitOverFlgAct(false))}
              >
                キャンセル
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={`${styles.downloadLimitOverOkButton}`}
                onClick={this.onClickCreateDownloadFile}
              >
                OK
              </Button>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    downloadLimitOverFlg: state.externaldata.downloadLimitOverFlg,
    downloadLimitOverMsg: state.externaldata.downloadLimitOverMsg,
  }),
  (dispatch) => ({
    setDownloadLimitOverFlgAct: (bool) => dispatch(setDownloadLimitOverFlg(bool)),
    executeFileDownloadAct: () => dispatch(executeFileDownload()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(CompanyDownloadComponent);
